import { Award, BookOpen, Bug, CalendarPlus, ClipboardCheck, CreditCard, FileText, Home, MessageCircle, ScrollText, ShoppingBag, Signpost, type LucideIcon } from 'lucide-react';

// Navigation de l'espace élève (refonte du 14/10/2026) : mêmes écrans qu'avant, libellés courts pour la barre du bas.

export type Tab =
  | 'dashboard'
  | 'code'
  | 'reserver'
  | 'commander'
  | 'paiements'
  | 'documents'
  | 'livret'
  | 'messages'
  | 'evaluation'
  | 'permis'
  | 'conditions'
  | 'support';

export interface NavItem {
  id: Tab;
  label: string;
  icon: LucideIcon;
}

/** Ordre d'affichage (barre du haut sur ordinateur, menu « Plus » sur téléphone). */
export const NAV: NavItem[] = [
  { id: 'dashboard', label: 'Accueil', icon: Home },
  // Révision du code : seulement si l'auto-école a ouvert l'accès à l'élève.
  { id: 'code', label: 'Code', icon: Signpost },
  { id: 'reserver', label: 'Réserver', icon: CalendarPlus },
  { id: 'messages', label: 'Messages', icon: MessageCircle },
  { id: 'paiements', label: 'Paiements', icon: CreditCard },
  { id: 'commander', label: 'Commander', icon: ShoppingBag },
  { id: 'documents', label: 'Documents', icon: FileText },
  { id: 'livret', label: 'Livret', icon: BookOpen },
  { id: 'evaluation', label: 'Évaluation', icon: ClipboardCheck },
  { id: 'permis', label: 'Mon permis', icon: Award },
  // Comme « Signaler un problème » (T14, 26/10/2026) : « Plus » (téléphone) et menu du compte (ordinateur).
  { id: 'conditions', label: 'Conditions de vente', icon: ScrollText },
  // Dernière entrée de « Plus » (téléphone) et du menu du compte (ordinateur) ; jamais dans les onglets du haut.
  { id: 'support', label: 'Signaler un problème', icon: Bug },
];

export const TAB_IDS = NAV.map((n) => n.id);

/** Pages du menu du compte (et de « Plus » sur téléphone), jamais dans les onglets du haut. */
export const ACCOUNT_TABS: Tab[] = ['conditions', 'support'];

/**
 * Section « Droit de rétractation » de « Conditions de vente », où est le bouton « Renoncer au contrat ici » (T14) :
 * ancre de l'adresse /conditions#retractation.
 */
export const WITHDRAWAL_ANCHOR = 'retractation';

/**
 * Barre du bas (téléphone, tablette) : quatre entrées, le reste dans « Plus ». La révision du code,
 * utilisée chaque jour, y prend la place des paiements (ou du livret) quand l'auto-école l'a ouverte.
 */
export function bottomTabs(items: NavItem[]): { main: NavItem[]; more: NavItem[] } {
  const has = (id: Tab) => items.some((i) => i.id === id);
  const wanted: Tab[] = has('code')
    ? ['dashboard', 'code', 'reserver', 'messages']
    : ['dashboard', 'reserver', 'messages', has('paiements') ? 'paiements' : 'livret'];
  const main = wanted.map((id) => items.find((i) => i.id === id)).filter((i): i is NavItem => !!i);
  return { main, more: items.filter((i) => !wanted.includes(i.id)) };
}

/** Pastille de non-lus (« 99+ » au-delà), avec le nombre lu par les lecteurs d'écran. */
export function unreadLabel(count: number) {
  return ` ${count} non lu${count > 1 ? 's' : ''}`;
}
